import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./ShowRoomBaghdadLocation.css";

import { LanguageContext } from "../../context/LanguageContext";

const ShowRoomBaghdadLocation = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const { currentLang } = useContext(LanguageContext);

  const [data, setData] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadLocation?lang=${currentLang}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Failed loading ShowRoomBaghdadLocation:", err);
      }
    };

    load();
  }, [API_BASE, currentLang]);

  if (!data) {
    return (
      <section className="showroom-location">
        <p className="loading">Loading...</p>
      </section>
    );
  }

  return (
    <section className="showroom-location">
      {/* ===== TOP SECTION ===== */}
      <div className="sr-top">
        <h1>{data.title}</h1>

        <p className="sr-subtext">{data.subtitle}</p>

        <p className="sr-desc">{data.description}</p>
      </div>

      {/* ===== BOTTOM SECTION ===== */}
      <div className="sr-bottom">
        <h3>
          {currentLang === "ar"
            ? "العنوان"
            : currentLang === "ku"
            ? "ناونیشان"
            : "Address"}
        </h3>

        <p>
          {data.address}{" "}
          <span className="bold">
            {currentLang === "ar"
              ? "ساعات العمل"
              : currentLang === "ku"
              ? "کاتەکانی کار"
              : "Opening hours"}
          </span>
        </p>

        <p className="sr-hours">{data.hours}</p>
      </div>
    </section>
  );
};

export default ShowRoomBaghdadLocation;
